var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[_c('ModalComponent',{attrs:{"name":"crear-etiqueta","title":"Crear nueva etiqueta"},on:{"close":_vm.close}},[_c('FormComponent',{attrs:{"etiqueta":_vm.tempTag},on:{"terminado":function($event){return _vm.crear()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }